import { generatedApi } from './api.generated';
import { createEndpointExports, createHookExports } from '@skynet/data-helpers';
import type { HookExports } from '@skynet/data-helpers';
import { DEX_EXCHANGES_API_ENDPOINTS as cfg } from './config';
import { mockDexExchanges } from './mock-dex-exchanges';
import type { DexListResponse } from './types';

/** Delay of the mocked list, so the page still renders its loading state. */
const MOCK_LIST_DELAY_MS = 500;

/**
 * DEX exchanges API on the shared DEX Web API base query.
 *
 * Neither endpoint provides cache tags: nothing in the dashboard mutates
 * exchanges, so there is nothing that could invalidate them.
 */
const enhancedDexExchangesApi = generatedApi.injectEndpoints({
  endpoints: (build) => ({
    // TODO(SKY-2783): replace with the real exchanges list endpoint.
    getDexesList: build.query<DexListResponse, void>({
      queryFn: async () => {
        await new Promise((resolve) => setTimeout(resolve, MOCK_LIST_DELAY_MS));

        return {
          data: {
            status: true,
            message: mockDexExchanges,
            total: mockDexExchanges.length,
          } satisfies DexListResponse,
        };
      },
    }),
  }),
});

export const dexExchangesApi: typeof enhancedDexExchangesApi = enhancedDexExchangesApi;

export const { useGetDexesListQuery } = dexExchangesApi;

export const hookExports: HookExports<typeof cfg, typeof dexExchangesApi> = createHookExports(
  cfg,
  dexExchangesApi,
);

const endpointExports = createEndpointExports(cfg, dexExchangesApi);

export const dexExchangesApiEndpoints: typeof endpointExports = endpointExports;
